import { buyDownsApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const BUY_DOWN_ACTION_TYPE = createNamedActions('buyDown', {
  GET_BUY_DOWNS: 'GET_BUY_DOWNS',
  CREATE_BUY_DOWN: 'CREATE_BUY_DOWN',
  EDIT_BUY_DOWN: 'EDIT_BUY_DOWN',
  DELETE_BUY_DOWN: 'DELETE_BUY_DOWN',
});

const buyDownsSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getBuyDownsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await buyDownsApi.getBuyDowns(params);

  return dispatch({
    type: BUY_DOWN_ACTION_TYPE.GET_BUY_DOWNS,
    payload: normalize(data, [buyDownsSchema]).entities.data,
  });
});

export const createBuyDownAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await buyDownsApi.createBuyDown(params);

  return dispatch({
    type: BUY_DOWN_ACTION_TYPE.CREATE_BUY_DOWN,
    payload: data,
  });
});

export const editBuyDownAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await buyDownsApi.editBuyDown(params);

  return dispatch({
    type: BUY_DOWN_ACTION_TYPE.EDIT_BUY_DOWN,
    payload: data,
  });
});

export const deleteBuyDownAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await buyDownsApi.deleteBuyDown(params);

  return dispatch({
    type: BUY_DOWN_ACTION_TYPE.DELETE_BUY_DOWN,
    payload: data,
    meta: params,
  });
});
